import { Component } from '@angular/core';

@Component({
  selector: 'rs-qr-code',
  templateUrl: 'qr-code.component.html',
  styleUrls: ['qr-code.component.scss']
})
export class QRCodeComponent {}
